import { GridColumns } from '@mui/x-data-grid-pro';
import { XGridOverflowCell } from 'app/components/Common/XGrid/cells/XGridOverflowCell';
import { XGridLinkCell } from 'app/components/Common/XGrid/cells/XGridLinkCell';
import { XGridSideBarViewCell } from 'app/components/Common/XGrid/cells/XGridSideBarViewCell';
import { XGridDefaultColumn } from 'app/components/Common/XGrid/cells/XGridDefaults';


export const targetMarginSearchGridColumns: GridColumns = [
  {
    field: 'marginType',
    headerName: 'Type',
    width: 120,
    sortable: true,
    renderCell: (params) => {
      const value = params.value;
      if (value === null || value === undefined || value === '') {
        return '--';
      }
      return value;
    },
  },
  {
    field: 'targetMarginId',
    headerName: 'Target Margin ID',
    width: 150,
    sortable: true,
    renderCell: (params) => {
      const value = params.value;
      if (value === null || value === undefined || value === '') {
        return '--';
      }
      return value;
    },
  },
  {
    field: 'targetMarginSource',
    headerName: 'Source',
    width: 200,
    sortable: true,
    renderCell: (params) => {
      const value = params.value;
      if (value === null || value === undefined || value === '') {
        return '--';
      }
      return value;
    },
  },
  {
    field: 'division',
    headerName: 'Division',
    width: 200,
    sortable: true,
    renderCell: (params) => {
      const value = params.value;
      if (value === null || value === undefined || value === '') {
        return '--';
      }
      return value;
    },
  },
  {
    ...XGridDefaultColumn,
    field: 'facilityId',
    headerName: 'Facility ID',
    width: 120,
    sortable: true,
    renderCell: (params) => {
      const facilityParams = {
        ...params,
        row: {
          ...params.row,
          previewDrawerViewerId: params.row.facilityId,
          previewDrawerViewerType: 2, // Type 2 for facility side panel
        }
      };
      return XGridOverflowCell(XGridSideBarViewCell('/facility/{0}', ['facilityId'], true))(
        XGridSideBarViewCell('/facility/{0}', ['facilityId']),
      )(facilityParams);
    },
  },
  {
    field: 'facility',
    headerName: 'Facility Name',
    width: 250,
    sortable: true,
    renderCell: (params) => {
      const value = params.value;
      if (value === null || value === undefined || value === '') {
        return '--';
      }
      return XGridOverflowCell(XGridLinkCell('/facility/{0}', ['facilityId'], true))(
        XGridLinkCell('/facility/{0}', ['facilityId']),
      )(params);
    },
  },
  {
    ...XGridDefaultColumn,
    field: 'orderId',
    headerName: 'Order ID',
    width: 120,
    sortable: true,
    renderCell: (params) => {
      const orderParams = {
        ...params,
        row: {
          ...params.row,
          previewDrawerViewerId: params.row.orderId,
          previewDrawerViewerType: 1,
        }
      };
      return XGridOverflowCell(XGridSideBarViewCell('/order/{0}', ['orderId'], true))(
        XGridSideBarViewCell('/order/{0}', ['orderId']),
      )(orderParams);
    },
  },
  {
    field: 'discipline',
    headerName: 'Discipline',
    width: 150,
    sortable: true,
    renderCell: (params) => {
      const value = params.value;
      if (value === null || value === undefined || value === '') {
        return '--';
      }
      return value;
    },
  },
  {
    field: 'specialtyAbbr',
    headerName: 'Specialty',
    width: 200,
    sortable: true,
    renderCell: (params) => {
      const value = params.value;
      if (value === null || value === undefined || value === '') {
        return '--';
      }
      return value;
    },
  },
  {
    field: 'subSpecialtyAbbr',
    headerName: 'Sub Specialty',
    width: 200,
    sortable: true,
    renderCell: (params) => {
      const value = params.value;
      if (value === null || value === undefined || value === '') {
        return '--';
      }
      return value;
    },
  },
  {
    field: 'state',
    headerName: 'State',
    width: 100,
    sortable: true,
    renderCell: (params) => {
      const value = params.value;
      if (value === null || value === undefined || value === '') {
        return '--';
      }
      return value;
    },
  },
  {
    field: 'targetMarginDefault',
    headerName: 'Target Margin - Default',
    width: 180,
    sortable: true,
    type: 'number',
        renderCell: (params) => {
          const value = params.value;
          if (value === null || value === undefined || value === '') {
            return '--';
          }
          return `${parseFloat(value).toFixed(2)}%`;
        },
  },
  {
    field: 'targetMarginDayShift',
    headerName: 'Target Margin - Day',
    width: 120,
    sortable: true,
    type: 'number',
      renderCell: (params) => {
        const value = params.value;
        if (value === null || value === undefined || value === '') {
          return '--';
        }
        return `${parseFloat(value).toFixed(2)}%`;
      },  
  },
  {
    field: 'targetMarginNightShift',
    headerName: 'Target Margin - Night',
    width: 120,
    sortable: true,
    type: 'number',
    renderCell: (params) => {
      const value = params.value;
      if (value === null || value === undefined || value === '') {
        return '--';
      }
      return `${parseFloat(value).toFixed(2)}%`;
    },
  },
  {
    field: 'targetMarginDayNightShift',
    headerName: 'Target Margin - Day/Night',
    width: 150,
    sortable: true,
    type: 'number',
    renderCell: (params) => {
      const value = params.value;
      if (value === null || value === undefined || value === '') {
        return '--';
      }
      return `${parseFloat(value).toFixed(2)}%`;
    },
  },
  {
    field: 'payRangeMinMaxPercentage',
    headerName: 'Pay Range Min/Max Percentage',
    width: 130,
    sortable: true,
    type: 'number',
    renderCell: (params) => {
      const value = params.value;
      if (value === null || value === undefined || value === '') {
        return '--';
      }
      return `${parseFloat(value).toFixed(2)}%`;
    },
  },
  {
    field: 'defaultWeeklyPay',
    headerName: 'Default Weekly Pay',
    width: 160,
    sortable: true,
    type: 'number',
    renderCell: (params) => {
      const value = params.value;
      if (value === null || value === undefined || value === '') {
        return '--';
      }
      return `$${parseFloat(value).toFixed(2)}`;
    },
  },
  {
    field: 'suppress',
    headerName: 'Suppress in JDH',
    width: 100,
    sortable: true,
    type: 'boolean',
    renderCell: (params) => {
      const value = params.value;
      if (value === null || value === undefined) {
        return '--';
      }
      if (value === 1 || value === true) {
        return 'Yes';
      } else if (value === 0 || value === false) {
        return 'No';
      }
      return value ? 'Yes' : 'No';
    },
  },
  {
    field: 'positions',
    headerName: 'Positions',
    width: 100,
    sortable: true,
    type: 'number',
    renderCell: (params) => {
      const value = params.value;
      if (value === null || value === undefined || value === '') {
        return '--';
      }
      return value;
    },
  },
];

export const targetMarginColumnVisibilityModel = {
  marginType: true,
  targetMarginId: false,
  targetMarginSource: true,
  division: true,
  facilityId: true,
  facility: true,
  orderId: true,
  discipline: true,
  specialtyAbbr: true,
  subSpecialtyAbbr: true,
  state: true,
  targetMarginDefault: true,
  targetMarginDayShift: true,
  targetMarginNightShift: true,
  targetMarginDayNightShift: true,
  payRangeMinMaxPercentage: true,
  defaultWeeklyPay: true,
  suppress: false,
  positions: false,
};
